import * as Yup from "yup";
import { POSTCODE_REGEX } from "@ds-developer/frontend";

export const learnerDetailsFormFieldsValidationSchema = Yup.object().shape({
  title: Yup.string().required("This field is required"),
  firstName: Yup.string()
    .min(1, "This field is required")
    .required("This field is required"),
  lastName: Yup.string().min(1, "This field is required").required({
    message: "This field is required",
  }),
  contactMobile: Yup.string()
    .length(11, "Please enter a valid phone number")
    .required({
      message: "This field is required",
    }),
  contactEmail: Yup.string().email("Must be a valid email address").required({
    message: "This field is required",
  }),
  addressLine1: Yup.string().min(1, "This field is required").required({
    message: "This field is required",
  }),
  addressLine2: Yup.string(),
  addressTown: Yup.string().min(1, "This field is required").required({
    message: "This field is required",
  }),
  addressPostcode: Yup.string()
    .matches(POSTCODE_REGEX, "Must be a valid postcode")
    .required("This field is required"),
  dateOfBirth: Yup.date().required("This field is required"),
});
